/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProfileDetailsDto } from '../models/profile-details-dto';
import { ProfilePagedDto } from '../models/profile-paged-dto';
import { ProfileSearchDto } from '../models/profile-search-dto';
import { PurchaseContactsResultDto } from '../models/purchase-contacts-result-dto';

@Injectable({
  providedIn: 'root',
})
export class ProfileService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation findProfiles
   */
  static readonly FindProfilesPath = '/profiles/search';

  /**
   * Search profiles.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findProfiles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findProfiles$Response(params?: {
    'X-On-Behalf-Of-User'?: string;
    body?: ProfileSearchDto
  }): Observable<StrictHttpResponse<ProfilePagedDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProfileService.FindProfilesPath, 'post');
    if (params) {
      rb.header('X-On-Behalf-Of-User', params['X-On-Behalf-Of-User'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProfilePagedDto>;
      })
    );
  }

  /**
   * Search profiles.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findProfiles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findProfiles(params?: {
    'X-On-Behalf-Of-User'?: string;
    body?: ProfileSearchDto
  }): Observable<ProfilePagedDto> {

    return this.findProfiles$Response(params).pipe(
      map((r: StrictHttpResponse<ProfilePagedDto>) => r.body as ProfilePagedDto)
    );
  }

  /**
   * Path part for operation purchaseProfiles
   */
  static readonly PurchaseProfilesPath = '/profiles/purchase';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `purchaseProfiles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  purchaseProfiles$Response(params: {
    'X-On-Behalf-Of-User'?: string;
    body: Array<string>
  }): Observable<StrictHttpResponse<PurchaseContactsResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProfileService.PurchaseProfilesPath, 'post');
    if (params) {
      rb.header('X-On-Behalf-Of-User', params['X-On-Behalf-Of-User'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PurchaseContactsResultDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `purchaseProfiles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  purchaseProfiles(params: {
    'X-On-Behalf-Of-User'?: string;
    body: Array<string>
  }): Observable<PurchaseContactsResultDto> {

    return this.purchaseProfiles$Response(params).pipe(
      map((r: StrictHttpResponse<PurchaseContactsResultDto>) => r.body as PurchaseContactsResultDto)
    );
  }

  /**
   * Path part for operation getProfileDetails
   */
  static readonly GetProfileDetailsPath = '/profiles/{profileId}';

  /**
   * Get profile details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProfileDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileDetails$Response(params: {
    'X-On-Behalf-Of-User'?: string;
    profileId: string;
  }): Observable<StrictHttpResponse<ProfileDetailsDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProfileService.GetProfileDetailsPath, 'get');
    if (params) {
      rb.header('X-On-Behalf-Of-User', params['X-On-Behalf-Of-User'], {});
      rb.path('profileId', params.profileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProfileDetailsDto>;
      })
    );
  }

  /**
   * Get profile details.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProfileDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfileDetails(params: {
    'X-On-Behalf-Of-User'?: string;
    profileId: string;
  }): Observable<ProfileDetailsDto> {

    return this.getProfileDetails$Response(params).pipe(
      map((r: StrictHttpResponse<ProfileDetailsDto>) => r.body as ProfileDetailsDto)
    );
  }

}
